<i *ngIf="getIcon()" [ngClass]="getIcon() + ' ' + this.getStyleClass()" style="margin-right: 5px;"></i>
<span>{{getPrefixLabelValue()}}</span>
<span [innerHTML]="getLabelValue()"></span>